import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/estate-agent-helping-man-woman-with-magnifying-glasses-choose-apartment-rent-flat-vector-illustration_98292-8690.jpg';

function AffordableHousingPrograms() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Affordable Housing Programs" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Affordable Housing Programs</h4>
              <p>
                This sub-department is dedicated to increasing access to affordable housing for low-income individuals and families.<br />
                Programs include housing subsidies, partnerships with non-profits, and development of affordable housing units.<br /><br />
                By providing affordable housing options, we aim to enhance community stability and improve quality of life.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Housing Subsidies for Low-Income Families</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Partnerships with Non-Profit Organizations</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Development of Affordable Housing Units</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to addressing the housing needs of our community by expanding affordable housing opportunities and ensuring access for all.
              </p>
            </div>
            <div>
              <Link to="/department/housing">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default AffordableHousingPrograms;
